import type { ReactNode } from "react";

import { classNames, Text } from "@alpacahq/ui/old";

import { Asterisk } from "./asterisk";

interface FieldProps {
  label: ReactNode;
  description?: string;
  required?: boolean;
  error?: boolean;
  errorMsg?: string;
  tooltip?: ReactNode;
  className?: string;
  htmlFor?: string;
  children: ReactNode;
}

// wraps input field with label and asterisk if required
export const Field = ({
  label,
  description,
  required,
  error,
  errorMsg,
  tooltip,
  className,
  htmlFor,
  children,
}: FieldProps) => {
  return (
    <div className={classNames("flex flex-col gap-3", className)}>
      <div className="flex w-full gap-2">
        <label htmlFor={htmlFor} className="font-medium text-gray-800 text-sm">
          {label}
        </label>
        <Asterisk required={required} className="text-xs" />
        {tooltip && tooltip}
        <FieldError error={error} errorMsg={errorMsg} />
      </div>
      <FieldDescription description={description} />
      {children}
    </div>
  );
};

export const FieldError = ({
  error,
  errorMsg,
}: {
  error?: boolean;
  errorMsg?: string;
}) => {
  return (
    error &&
    errorMsg && (
      <span className="ml-auto flex grow justify-end text-right text-red-500 text-xs">
        {errorMsg}
      </span>
    )
  );
};

export const FieldDescription = ({ description }: { description?: string }) => {
  return description ? (
    <Text className="mb-2 text-gray-600 text-sm">{description}</Text>
  ) : null;
};
